<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre v-if="linea === 1" style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 36px; font-weight:800; text-align: center; text-transform: uppercase;">'Autobuses a otro nivel'</pre>
          <pre v-else style="margin-top: 0px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 36px; font-weight:800; text-align: center; text-transform: uppercase;">'Comodidad a tu alcance'</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:900; text-align: center; text-transform: uppercase;">Comprobante no valido como Pase de Abordar</pre>
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 23px; font-weight:900; text-align: center; text-transform: uppercase;">Comprobante: Reserva de pasaje</pre>
          <table style="border-collapse: collapse; width: 98%; font-size: 28px; text-align: left;">  
            <tr>    
              <td style="padding-right: 2px; font-weight:600;">No de Pase</td>
              <td style="padding-right: 2px; font-weight:600;"><!--No de Pase--></td>  
            </tr>  
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.id}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;"><!--{{boleto.id}}--></td>  
            </tr>  
            <tr> 
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Nombre pasajero</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Tipo de pasajero</td>   
            </tr>    
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.nombre_pasajero}}</td>
              <td v-if="boleto.descuento != undefined && boleto.descuento != null && boleto.descuento.valor != 0" style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span>{{ boleto.descuento.nombre }}</span>
              </td>
              <td v-else style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span>Adulto</span>
              </td>      
            </tr>  
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Origen</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Asiento</td>   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_origen}}</td>
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.asiento}}</td>  
            </tr> 
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Destino</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Fecha de viaje</td>
              <!--<td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Tipo de servicio</td>-->   
            </tr>
            <tr>    
              <td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_destino}}</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('DD-MM-YYYY')}}</td>
              <!--<td style="padding-right: 2px; text-transform: uppercase; font-weight:800;">
                <span v-if="(boleto.asiento === null)">Blanco</span>
                <span v-else>
                  <span v-if="(boleto.categoria_asiento_id === 1)">Primera</span>
                  <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                  <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
                </span>
              </td>--> 
            </tr>
            <!--
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Fecha de viaje</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Hora de viaje</td>   
            </tr>
            <tr>    
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('DD-MM-YYYY')}}</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('HH:mm')}} Hrs</td>  
            </tr>
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Bajada</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Subida</td>   
            </tr>
            <tr>    
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.paradero_origen}}</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.paradero_destino}}</td>  
            </tr>
            <tr>    
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Forma de pago</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Tipo de venta</td>
            </tr>
            <tr>    
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.metodo }}</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.lugar_emision }}</td>   
            </tr>--> 
            <tr>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Importe Total</td>
              <td style="padding-right: 2px; margin-top: 8px; font-weight:600;">Monto abonado</td>   
            </tr>
            <tr>    
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">${{ boleto.monto_total_pagar }}</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ acumulado }}</td>
            </tr> 
          </table>
          <span style="border-collapse: collapse; width: 100%; font-size: 22px; padding: 8px;">____________________________________________</span>
          <p style="font-family: 'Montserrat', sans-serif; width: 100%; font-size: 26px; padding: 8px; font-weight: 800;">Saldo a pagar: ${{boleto.monto_total_pagar - acumulado}}</p>
          <p style="font-family: 'Montserrat', sans-serif; width: 98%; font-size: 25px; padding: 8px; text-align: center; font-weight: 800;">Esta reserva puede ser confirmada en cualquiera de nuestras agencias a lo largo del pais, valida hasta 2 horas antes de la salida</p>
          <p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
            {{user.username}}/{{boleto.created_at | moment('DDMMYYYY')}}/{{ boleto.created_at | moment('HH:mm') }} 
          </p>
          <!--<span style="border-collapse: collapse; font-family: 'Montserrat', sans-serif; width: 100%; font-size: 18px; padding: 8px; font-weight: bold;">{{user.agencia_activa +'  -  '+ user.username +'  -'}}</span>
          <span style="border-collapse: collapse; font-family: 'Montserrat', sans-serif; width: 100%; font-size: 18px; padding: 8px; font-weight: bold;">{{new Date(boleto.created_at) | moment('DD-MM-YYYY HH:mm')}}</span>
          <p style="border-collapse: collapse; font-family: 'Montserrat', sans-serif; width: 100%; font-size: 22px; padding: 8px;">____________________________________________</p>
          <p style="border-collapse: collapse; font-family: 'Montserrat', sans-serif; width: 100%; font-size: 22px; padding: 8px; text-align: center;">Reserva puede ser confirmada en cualquiera de nuestras agencias a lo largo del pais</p>
          <span style="border-collapse: collapse; width: 100%; font-size: 22px; padding: 8px;">____________________________________________</span>
          <p style="border-collapse: collapse; font-family: 'Montserrat', sans-serif;  width: 100%; font-size: 22px; padding: 8px; text-align: center;">Reserva valida hasta 2 horas antes de salida</p>--> 
        <pre style="margin-top: 4px; font-family: 'Montserrat', sans-serif; font-size: 18px; font-weight:600; text-align: center; text-transform: uppercase;">Para facturar, conoce el aviso de privacidad y nuestras políticas comerciales en www.platinumline.mx</pre>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    boleto: {required: false},
    user: {required: false},
    acumulado: {required: false},
    linea: {required: false}
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>